'use strict';

angular.module('casist.ubytovanie', [
  'ui.scroll'
]);